import React, { MouseEventHandler, useEffect, useState } from 'react'

import { ExpenseCategory } from 'core/application/adminDashboard/benefitDetails/design/expenseCategories'

import Radio from 'common/components/dataEntry/components/Radio'
import RadioButton from 'common/components/dataEntry/components/RadioButton'
import Icon from 'common/components/general/Icon'

import './ExpenseType.less'

const CategoryFilter = ({ categories, onCategoryFilter, removeSelected }) => {
  const [selectedCategory, setSelectedCategory] = useState<ExpenseCategory>(null)

  useEffect(() => {
    setSelectedCategory(null)
  }, [removeSelected])

  return (
    <div className={'text-left'}>
      <Radio.Group
        value={selectedCategory !== null ? selectedCategory : null}
        onChange={(e: any) => {
          setSelectedCategory(e.target.value)
          onCategoryFilter(e.target.value)
        }}
      >
        {categories.map((item) => (
          <RadioButton
            key={item.id}
            value={item.id}
            className="m-4 expense-category font-12"
            onClick={() => {
              if (selectedCategory && item.id === selectedCategory) {
                setSelectedCategory(null)
                onCategoryFilter(null)
              } else {
                setSelectedCategory(item.id)
                onCategoryFilter(item.id)
              }
            }}
          >
            <Icon type={`far fa-${item.icon}`} fontAwesome /> {item.name}
          </RadioButton>
        ))}
      </Radio.Group>
    </div>
  )
}

export default CategoryFilter
